import { ArrowSmallDownIcon, ArrowSmallUpIcon } from '@heroicons/react/20/solid';
import Currency from '../../components/currency/Currency';
import { Worksheet } from '../../types/worksheet';
import { getVarianceDirectionColor } from '../../utilities/variance-color';

type WorksheetVarianceProps = {
    worksheet: Worksheet;
    asPercent: boolean;
    onClick: () => void;
    textColor?: string;
};

function WorksheetVariance({ worksheet, asPercent, onClick, textColor = 'text-gray-700' }: WorksheetVarianceProps): JSX.Element {
    if (!worksheet.account) {
        return <></>;
    }
    return worksheet.account.variance === 0 ? (
        <p className=" text-gray-600 text-sm dark:text-white/[0.6]">{'-'}</p>
    ) : (
        <div className={`flex items-center cursor-pointer text-sm ${textColor}`} onClick={onClick}>
            <span className={`${getVarianceDirectionColor(worksheet.account)}`}>
                {worksheet.account.variance < 0 ? <ArrowSmallDownIcon className="w-4 h-4" /> : <ArrowSmallUpIcon className="w-4 h-4 " />}
            </span>
            {asPercent ? (
                <p className=" dark:text-white/[0.6]">{Math.abs(worksheet.account.variancePercent)}%</p>
            ) : (
                <Currency value={Math.abs(worksheet.account.variance)} className="dark:text-white/[0.87]" />
            )}
        </div>
    );
}

export default WorksheetVariance;
